import { Component, OnInit, Input, forwardRef, Output, EventEmitter, Optional, Self, Inject, OnDestroy, Injector, AfterViewInit, ElementRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, AbstractControl, NG_VALIDATORS, NgControl, FormControl, Validators, RequiredValidator } from '@angular/forms';

@Component({
  selector: 'ngx-input',
  templateUrl: './ngx-cm-input.component.html',
  styleUrls: ['./ngx-cm-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NgxCmInputComponent),
      multi: true
    }
  ]
})
export class NgxCmInputComponent implements OnInit, OnDestroy, AfterViewInit, ControlValueAccessor {
  @Input()
  Label;

  @Input()
  Type = 'text';

  @Input()
  IconClass;

  @Input()
  MaxLength = 100;

  @Input()
  AlphaNumaricOnly = false;

  @Input()
  AlphabeticalOnly = false;

  @Input()
  NumbersOnly = false;

  @Input()
  AllowedChars;

  _show = true;
  @Input()
  set Show(value) {
    this._show = value;
    if (!value) {
      this.element.nativeElement.style.display = 'none';
      this.clearValidators();
    } else {
      this.element.nativeElement.style.display = 'block';
      this.setValidators();
    }
  }
  get Show() {
    return this._show;
  }

  @Output()
  Focus = new EventEmitter();

  @Output()
  Blur = new EventEmitter();

  FocusIn = false;

  onChange;

  context = {
    value: null,
    control: null,
    validators: null,
    required: false
  };

  constructor(
    private injector: Injector,
    private element: ElementRef,
    @Optional() @Self() @Inject(NG_VALIDATORS) private validators
  ) {
    this.isControlRequired();
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    const ngControl = this.injector.get(NgControl, null);
    if (ngControl) {
      this.context.control = ngControl.control as FormControl;
    }
    if (!this.Show) {
      this.clearValidators();
    }
  }

  ngOnDestroy() {
  }

  writeValue(value) {
    this.context.value = value;
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched() {

  }

  valueUpdate(value) {
    this.context.value = value;
    if (this.onChange) {
      this.onChange(value);
    }
  }

  onKeyDown(e) {
    // console.log(e)
    if (
      e.keyCode === 8 ||
      e.keyCode === 9 ||
      (e.keyCode === 65 && e.ctrlKey) ||
      (this.AllowedChars && this.AllowedChars.indexOf(e.key) !== -1) ||
      (this.Type === 'email' && ((e.keyCode === 50 && e.shiftKey) || (e.keyCode === 190 && !e.shiftKey))) ||
      (this.Type === 'phone' && ((e.keyCode === 189 && !e.shiftKey) || (e.keyCode === 187 && e.shiftKey)))
    ) {
      return;
    }

    if (
      this.AlphaNumaricOnly &&
      !(e.keyCode >= 65 && e.keyCode <= 90) &&
      !(e.keyCode >= 48 && e.keyCode <= 57 && !e.shiftKey)
    ) {
      e.preventDefault();
      return;
    }

    if (
      this.NumbersOnly &&
      !(e.keyCode >= 48 && e.keyCode <= 57 && !e.shiftKey)
    ) {
      e.preventDefault();
      return;
    }

    if (
      this.AlphabeticalOnly &&
      !(e.keyCode >= 65 && e.keyCode <= 90)
    ) {
      e.preventDefault();
      return;
    }

    if (
      this.MaxLength &&
      this.context.value &&
      this.context.value.length >= this.MaxLength
    ) {
      e.preventDefault();
      return;
    }
  }

  isControlRequired() {
    if (this.validators) {
      this.context.validators = this.validators;

      this.validators.map(validator => {
        if (validator instanceof RequiredValidator) {
          this.context.required = true;
        }
      });
    }
  }

  setValidators() {
    if (this.context.control && this.context.validators) {
      this.context.control.setValidators(this.context.validators);
      this.context.control.updateValueAndValidity();
    }
  }

  clearValidators() {
    if (this.context.control) {
      this.context.control.clearValidators();
      this.context.control.updateValueAndValidity();
    }
  }
}
